export function instanceOf(object, find) {
    return find in object;
}
//# sourceMappingURL=instance-of.func.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@angular-package/change-detection/decorator/src/instance-of.func.js
// module id = 910
// module chunks = 7